<template>
    <div class="product-detail__price" :style="!mounted ? 'opacity: 0;' : 'opacity: 1'">
        <div v-if="discountPercent" class="product-detail__discount">
            <span>
                {{ discountPercent }}
            </span>
        </div>
        <div class="product-detail-price" :class="{ 'product-detail-price--sale': hasCrossPrice }">
            <template v-if="showDynamicPrice">
                <span :inner-html.prop="$translate('Ceres::Template.dynamicVariationPrice', { price: $options.filters.currency(variationTotalPrice, true) })"></span>
            </template>
            <template v-else>
                <span :inner-html.prop="variationTotalPrice | currency(true)"></span>
            </template>
            <span class="product-detail-price--uvp" v-if="showCrossPrice && hasCrossPrice">
                <del>
                    <template v-if="hasSpecialOffer">
                        {{ currentVariation.prices.default.data['unitPrice'+appendNet] | itemCrossPrice(true) }}
                    </template>
                    <template v-else>
                        {{ currentVariation.prices.rrp.data['unitPrice'+appendNet] | currency }}
                    </template>
                </del>
            </span>
        </div>

        <div class="product-detail-price__additional">
            <div class="product-detail-price--base"
                 v-if="currentVariation.unit">
                <span v-if="currentVariation.variation.mayShowUnitPrice">
                    ({{ $translate("OD3dprimaV2::Template.basePrice") }}
                    {{ variationGraduatedPriceContent | specialOffer(currentVariation.prices, 'data', 'basePrice'+appendNet) | currency }}/{{ unitName }})
                </span>
                <span class="d-none d-md-inline">&nbsp;</span>
            </div>

            <div class="product-detail-price--vat">
                <template v-if="appendNet !== ''">
                    {{ $translate("Ceres::Template.singleItemExclVAT") }}
                </template>
                <template v-else>
                    {{ $translate("Ceres::Template.singleItemInclVAT") }}
                </template>
                {{ $translate("Ceres::Template.singleItemExclusive") }}
                <a v-if="hasShippingCostsCategoryId"
                   data-toggle="modal"
                   href="#shippingscosts"
                   :title="$translate('Ceres::Template.singleItemShippingCosts')">
                    {{ $translate("Ceres::Template.singleItemShippingCosts") }}
                </a>
                <a v-else :title="$translate('Ceres::Template.singleItemShippingCosts')">
                    {{ $translate("Ceres::Template.singleItemShippingCosts") }}
                </a>
            </div>
        </div>

    </div>
</template>

<script>
import {isNullOrUndefined} from 'ceres/app/helper/utils';
import Vue from 'vue';
import {mapState} from "vuex";

export default {
    name: 'item-price',

    props: {
        showCrossPrice: {
            type: Boolean,
            default: true
        }
    },

    inject: {
        itemId: {
            default: null
        }
    },

    data() {
        return {
            mounted: false
        }
    },

    computed: {
        ...mapState({
            currentPriceType: state => state.localization.currentPriceType
        }),
        currentVariation() {
            return this.$store.getters[`${this.itemId}/currentItemVariation`]
        },
        hasCrossPrice() {
            const hasRrpPrice = !!this.currentVariation.prices.rrp &&
                this.currentVariation.prices.rrp.unitPrice.value > this.currentVariation.prices.default.unitPrice.value;

            const hasBeforePrice = this.hasSpecialOffer &&
                !!this.currentVariation.prices.default &&
                this.currentVariation.prices.default.unitPrice.value > this.currentVariation.prices.specialOffer.unitPrice.value;

            return hasRrpPrice || hasBeforePrice;
        },
        hasSpecialOffer() {
            return !!this.currentVariation.prices.specialOffer;
        },
        showDynamicPrice() {
            const state = this.$store.state.items[this.itemId];
            return App.config.item.showPleaseSelect && App.isCheapestSorting
                && (state.variationSelect && !state.variationSelect.isVariationSelected)
                && (state.pleaseSelectVariationId === this.currentVariation.variation.id
                    || state.pleaseSelectVariationId === 0);
        },
        discountPercent() {

            let percent = 0;

            if (!isNullOrUndefined(this.currentVariation.prices.specialOffer)) {
                percent = (1 - this.currentVariation.prices.specialOffer.unitPrice.value / this.currentVariation.prices.default.unitPrice.value) * -100;
            } else if(!isNullOrUndefined(this.currentVariation.prices.rrp)) {
                percent = (1 - this.currentVariation.prices.default.unitPrice.value / this.currentVariation.prices.rrp.unitPrice.value) * -100;
            }

            if (percent < 0) {
                return percent.toFixed(this.decimalCount).replace('.', App.decimalSeparator) + '%';
            }

            return false;
        },
        hasShippingCostsCategoryId() {
            return App.config.global.shippingCostsCategoryId > 0;
        },
        appendNet() {

            if(this.currentPriceType === 'b2b') {
                return 'Net';
            }

            return '';
        },
        variationGraduatedPrice() {
            return this.$store.getters[`${this.itemId}/variationGraduatedPrice`].data['basePrice'+this.appendNet];
        },
        variationGraduatedPriceContent() {
            return this.variationGraduatedPrice / this.currentVariation.unit.content;
        },
        variationPropertySurcharge() {

            let variationPropertySurcharge = this.$store.getters[`${this.itemId}/variationPropertySurcharge`];

            if(this.currentPriceType === 'b2b' && variationPropertySurcharge > 0) {
                variationPropertySurcharge = variationPropertySurcharge / (1 + (this.currentVariation.prices.default.vat.value / 100));
            }

            return variationPropertySurcharge;
        },
        variationTotalPrice() {
            //no net price logic
            if (this.currentVariation.item.itemType === 'set') {
                return this.$store.getters.itemSetTotalPrice;
                //no net price logic only variationPropertySurcharge cause its need for price
            }else if (this.currentVariation.item.itemType !== 'set' && this.$store.getters.isItemSet) {
                return this.currentVariation.prices.set.price.value + this.variationPropertySurcharge;
            }else {

                const graduatedPrice = this.variationGraduatedPrice ? this.variationGraduatedPrice : 0;

                if (!isNullOrUndefined(graduatedPrice)) {

                    const specialOfferPrice = Vue.filter('specialOffer').apply(
                        Object,
                        [graduatedPrice, this.currentVariation.prices, 'data', 'price' + this.appendNet]
                    );

                    return specialOfferPrice === 'N / A' ? specialOfferPrice : this.variationPropertySurcharge + specialOfferPrice;
                }
            }

            return null;
        },
        unitName() {
            if(this.currentVariation.unit.unitOfMeasurement === 'KGM') {
                return 'kg';
            }
            if(!isNullOrUndefined(this.currentVariation.unit.names.name)) {
                return this.currentVariation.unit.names.name;
            }
            return '';
        }
    },

    mounted() {
        this.mounted = true;
    }
}
</script>
